/**
 * Check if array has value and if array
 * @param arg Array to check
 * @returns bolead true if array.length > 0
 */

const HCheckArray = (arg: unknown) => {
  if (!Array.isArray(arg)) return false;
  if (arg.length == 0) return false;
  return true;
};
export default HCheckArray;
